import { readable } from "svelte/store";

// keyCode 17 is Ctrl
// keyCode 91 is Cmd on macOS
export const CtrlKeyDown = readable(false, function start(set) {
	document.addEventListener("keydown", e => {
		if (e.keyCode === 17 || e.keyCode === 91) set(true);
	});
	document.addEventListener("keyup", e => {
		if (e.keyCode === 17 || e.keyCode === 91) set(false);
	});
});

export const ShiftKeyDown = readable(false, function start(set) {
	document.addEventListener("keydown", e => {
		if (e.keyCode === 16) set(true);
	});
	document.addEventListener("keyup", e => {
		if (e.keyCode === 16) set(false);
	});
});

export const AltKeyDown = readable(false, function start(set) {
	document.addEventListener("keydown", e => {
		if (e.keyCode === 18) set(true);
	});
	document.addEventListener("keyup", e => {
		if (e.keyCode === 18) set(false);
	});
});
